import BigNumber from 'bignumber.js';

import { DAYS_OF_YEAR } from '@/classes/common/Constants';
import AbstractデータService from '@/classes/service/AbstractデータService';

export default class 借入返済Utility {
  // ------------------------------------------------------------------
  // public static methods
  // ------------------------------------------------------------------

  /**
   * 元利均等を計算
   *
   * @param 当初金利
   * @param 返済回数
   * @param 借入金額
   * @returns
   */
  public static calc元利均等(当初金利: number, 返済回数: number, 借入金額: number): number {
    const 利率 = 当初金利 / 1200; // 100 で割って % にした後 12 で割って月利に変換
    return this.calcPMT(利率, 返済回数, 借入金額 * -1, 0);
  }

  /**
   * 利息を計算
   *
   * @param 前月残高
   * @param 金利
   * @param 前月日数
   * @param bnRoundingMode
   * @returns
   */
  public static calc利息(
    前月残高: number,
    金利: number,
    前月日数: number,
    bnRoundingMode: BigNumber.RoundingMode
  ): number {
    return AbstractデータService.calcPercentByBigNumber(
      前月残高,
      (金利 / 100) * 前月日数,
      DAYS_OF_YEAR,
      bnRoundingMode
    );
  }

  // ------------------------------------------------------------------
  // private static methods
  // ------------------------------------------------------------------
  /**
   * 支払い計算(Excel の PMT 関数を再現)
   *
   * @param 利率
   * @param 期間
   * @param 現在価値
   * @param 将来価値
   * @returns
   */
  private static calcPMT(利率: number, 期間: number, 現在価値: number, 将来価値: number): number {
    const 複利 = Math.pow(1 + 利率, 期間);
    return Math.trunc((利率 / (複利 - 1)) * (現在価値 * 複利 + 将来価値) * -1);
  }
}
